export enum AuthActions {
  CREATE_ACCOUNT = 'createAccount',
  CREATE_ACCOUNT_ERROR = 'createAccountError',
  LOGIN = 'entrar_conta',
  FORGOT_PASSWORD = 'esqueci_senha',
  RECOVER_PASSWORD = 'recuperar_senha',
  GO_TO_LOGIN = 'ir_para_login',
  SUCCESSFUL_PJ_LOGIN = 'login_sucesso',
  UNSUCCESSFUL_PJ_LOGIN = 'login_insucesso',
  // SET_NEW_PASSWORD = 'definir_senha',
  SUCCESSFUL_RESET_PASSWORD = 'nova_senha_sucesso',
  UNSUCCESSFUL_RESET_PASSWORD = 'nova_senha_insucesso'
}
